import { api_configuration } from "../../common";
import api_views = api_configuration.libraries.gui_definition_lib.types.views.alan_api;

export default function (query: api_views.Cqueries): string {
	return query.path;
}
